import { ValueProvider } from '@angular/core';
import { provideCmsStructure } from '@spartacus/storefront';

export const defaultCmsContentProviders: ValueProvider[] = [
  provideCmsStructure({
    componentId: 'HamburgerMenuComponent',
    pageSlotPosition: 'PreHeader',
  }),
  provideCmsStructure({
    componentId: 'LoginComponent',
    pageSlotPosition: 'SiteLogin',
  }),
  provideCmsStructure({
    componentId: 'SdCMSLoginButtonComponent',
    pageSlotPosition: 'SiteLoginButton',
  }),
  provideCmsStructure({
    componentId: 'MobileMenuComponent',
    pageSlotPosition: 'MobileMenu',
  }),
  provideCmsStructure({
    componentId: 'SdCMSChatMobileMenuComponent',
    pageSlotPosition: 'ChatMenuMobile',
  }),
];
